/**
 * MEERHOO — cart drawer: portal to body (fixes fixed positioning inside header blur/transform)
 */
(function () {
  function syncCartOpen() {
    var open = !!document.querySelector('.js-mini-cart.cardraw.active');
    document.documentElement.classList.toggle('mh-cart-open', open);
  }

  function portalDrawer() {
    document.querySelectorAll('.js-mini-cart.cardraw').forEach(function (wrap) {
      if (wrap.dataset.mhCartPortal === '1') return;

      var panel = wrap.querySelector('.mini-cart-content');
      var overlay = wrap.querySelector('.overlaycart');
      if (!panel) return;

      wrap.dataset.mhCartPortal = '1';
      panel.classList.add('mh-cart-drawer');
      document.body.appendChild(panel);

      if (overlay) {
        overlay.classList.add('mh-cart-overlay');
        document.body.appendChild(overlay);
      }

      if ('MutationObserver' in window) {
        var mo = new MutationObserver(syncCartOpen);
        mo.observe(wrap, { attributes: true, attributeFilter: ['class'] });
      }
    });

    syncCartOpen();
  }

  function bindClose() {
    document.addEventListener(
      'click',
      function (e) {
        if (e.target.closest('.mh-cart-overlay') || e.target.closest('.mh-cart-drawer .close')) {
          document.querySelectorAll('.js-mini-cart.cardraw').forEach(function (w) {
            w.classList.remove('active');
          });
          syncCartOpen();
        }
      },
      true
    );
  }

  function init() {
    portalDrawer();
    bindClose();
    syncCartOpen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
